import { Trans } from "@lingui/react/macro";
import { Column } from "@tanstack/react-table";

import { invariant } from "@/common/utils/invariant";

const Filter = <T,>({
  column,
  onFilterChange,
  value,
}: {
  column: Column<T, unknown>;
  onFilterChange: (key: string, value: string) => void;
  value: string;
}) => {
  // @ts-expect-error meta type
  const { filterKey } = column.columnDef.meta ?? {};
  invariant(
    filterKey,
    // eslint-disable-next-line lingui/no-unlocalized-strings
    `<Filter /> filterKey is not set for column: ${column.columnDef.id}`,
  );

  return (
    <input
      className="mt-2 rounded-lg border md:max-w-[150px]"
      onChange={(e) => onFilterChange(filterKey!, e.target.value)}
      type="text"
      value={value}
    />
  );
};

const SelectFilter = <T,>({
  column,
  onFilterChange,
  value,
  values,
}: {
  column: Column<T, unknown>;
  onFilterChange: (key: string, value: string) => void;
  value: string;
  values: Array<{ label: string; value: string }>;
}) => {
  // @ts-expect-error meta type
  const { filterKey } = column.columnDef.meta ?? {};
  invariant(
    filterKey,
    // eslint-disable-next-line lingui/no-unlocalized-strings
    `<SelectFilter /> filterKey is not set for column: ${column.columnDef.id}`,
  );
  return (
    <select
      className="mt-2 rounded-lg border md:max-w-[150px]"
      onChange={(e) => onFilterChange(filterKey!, e.target.value)}
      value={value}
    >
      <option value="">
        <Trans>Vše</Trans>
      </option>
      {values.toSorted().map((value) => (
        <option key={value.value} value={value.value}>
          {value.label}
        </option>
      ))}
    </select>
  );
};

export { Filter, SelectFilter };
